import { FC } from 'react'
import { Divider, Form, Space } from 'antd'
import MaterialRequirements from './material-requirements/material-requirements'
import CalculationPosition from '../../../../../types/api/calculation-position'
import { useWatch } from 'antd/es/form/Form'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { getMinSelectableMaterialWidth } from '../../../../../helpers/material-width'

interface MaterialsCardProps {
    namePath: number
}

const MaterialsCard: FC<MaterialsCardProps> = ({ namePath }) => {
    // TODO: Нужно подумать как система будет сама указывать как лучше выбрать материал
    /**
     * например есть есть в наличии, то сразу вставить его
     * если нет, то указать его заказ
     *
     * а если это поведение не подходит, то можно будет сделать разрез
     */

    const form = useFormInstance()
    const nameOfCalculationPosition = ['list', namePath, 'calculationPosition']
    const position: CalculationPosition =
        useWatch(nameOfCalculationPosition) || form.getFieldValue(nameOfCalculationPosition)
    const necessary = position.calculated?.materialLength
    const minMaterialWidth = getMinSelectableMaterialWidth(
        position.material?.width ?? position.calculated?.materialWidth
    )

    return (
        <>
            <Divider orientation={'left'}>Резервирование основного материала</Divider>

            <MaterialRequirements
                namePath={[namePath, 'materialRequirements']}
                prefix={['list']}
                minMaterialWidth={minMaterialWidth}
                necessary={necessary}
            />

            <Divider orientation={'left'}>Резервирование дополнительных материалов</Divider>

            <Form.List name={[namePath, 'additionalMaterialRequirements']}>
                {fields => (
                    <Space style={{ width: '100%' }} direction={'vertical'} size={12}>
                        {fields.map(field => (
                            <MaterialRequirements
                                key={field.key}
                                namePath={[field.name]}
                                prefix={['list', namePath, 'additionalMaterialRequirements']}
                                unrestrictedWidths
                                necessary={necessary}
                            />
                        ))}
                    </Space>
                )}
            </Form.List>
        </>
    )
}

export default MaterialsCard
